import { render } from "./SharedCopyNotice.vue?vue&type=template&id=6a361626"
import script from "./SharedCopyNotice.vue?vue&type=script&lang=js"
export * from "./SharedCopyNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__